import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';

import { isOnMobile } from 'utils/device-utils';
import LanguageService from 'services/Language.service';

import messages from './CurrentReportsView.intl';
import currentReportsMdMessages from './CurrentReportsMd.intl';
import currentReportsSmMessages from './CurrentReportsSm.intl';

import { ANCHOR } from 'common/consts/common';
import { LOAD_STATES } from 'common/consts/common';

import { generateYearsFilterArray } from 'utils/date-utils';

//components
import ArticlesPage from 'common/components/ArticlesPage/ArticlesPage';
import PageNotFound from 'views/PageNotFound/PageNotFoundView';

import CurrentReportsStore from 'stores/CurrentReports.store';
import TaxonomyStore from 'stores/Taxonomy.store';
import { observer } from 'mobx-react';
import { observable, reaction, action, computed, runInAction } from 'mobx';
import ContentStore from 'stores/Content.store';

@injectIntl
@withRouter
@observer
export default class CurrentReportsView extends Component {
  taxonomies = TaxonomyStore;
  filtersList = generateYearsFilterArray({
    first: {
      text: this.props.intl.formatMessage(messages.filter),
      value: ''
    },
    from: 2021
  });

  state = {
    isMobile: isOnMobile(),
    selectedFilter: this.props.match.params.category
      ? this.filtersList.find(
          filter => filter.value === this.props.match.params.category
        )
      : this.filtersList[0]
  };

  criteria = observable({
    page: CurrentReportsStore.latestState.page,
    category: CurrentReportsStore.latestState.category,
    publishYear:
      this.state.selectedFilter || CurrentReportsStore.latestState.publishYear,
    limit: 5
  });

  latestNews = observable([]);
  loadState = observable.box('');
  isExploited = false;

  currentLanguage = LanguageService.getLang();

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    reaction(() => this.criteria.category, () => this.latestNews.clear());
    reaction(() => this.criteria.publishYear, () => this.latestNews.clear());
  }

  componentWillUnmount() {
    if (!this.state.selectedFilter) {
      return;
    }

    CurrentReportsStore.latestState = {
      data: [...this.latestNews],
      page: this.criteria.page,
      isExploited: this.isExploited,
      category: this.criteria.category,
      publishYear: this.criteria.publishYear
    };

    window.removeEventListener('resize', this.updateDimensions);
  }

  @action
  updateCriteria(newCriteria) {
    Object.assign(this.criteria, newCriteria);
    this.fetchLatestCurrentReports(this.criteria);
  }

  @Bind()
  async showMore() {
    this.updateCriteria({
      page: this.criteria.page + 1
    });
  }

  async fetchLatestCurrentReports(criteria) {
    const { data } = await CurrentReportsStore.fetchLatestCurrentReports(
      criteria
    );

    runInAction(() => {
      this.latestNews.push(...data);
      CurrentReportsStore.latestState.data = [];
    });
  }

  @computed
  get criteriaKey() {
    return JSON.stringify(this.criteria);
  }

  @computed
  get isLoaded() {
    return this.loadState.get() === LOAD_STATES.LOADED;
  }

  render() {
    const { selectedFilter } = this.state;
    if (!this.state.selectedFilter) {
      return <PageNotFound />;
    }

    return (
      <ArticlesPage
        messages={messages}
        viewWithOnlyNews
        categorySlug={ANCHOR.CURRENT_REPORTS}
        filtersList={this.filtersList}
        selectedFilter={selectedFilter}
        criteria={this.criteria}
        criteriaKey={this.criteriaKey}
        fetchLatestNews={this.fetchLatestCurrentReports}
        seoContent={
          ContentStore.content && ContentStore.content.currentReportsSEO
        }
        latestNews={this.latestNews}
        isExploited={this.isExploited}
        articleNoteMdMessages={currentReportsMdMessages}
        articleNoteSmMessages={currentReportsSmMessages}
        otherNews={CurrentReportsStore.otherCurrentReports}
        categoryPath="news.currentReportsCategory.value"
        withReturnToInvestors
        showMore={this.showMore}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CurrentReports/CurrentReportsView.js